export default function Marquee({ items }) {
  const Row = ({ hidden }) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-mono text-[11px] uppercase tracking-[0.3em] text-[#94A3B8]">
            {item}
          </span>
          <span className="text-[9px] text-[#00F0FF]">◆</span>
        </span>
      ))}
    </div>
  );
  return (
    <div
      className="marquee overflow-hidden border-y border-white/[0.07] bg-[#0E1422]/70 py-5"
      data-testid="marquee"
    >
      <div className="marquee-track flex w-max">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
